import React from "react";
import bagGlyph from "../../assets/glyphs/bag.png";
import popcornGlyph from "../../assets/glyphs/popcorn.png";
import shareGlyph from "../../assets/glyphs/share.png";
import captionsGlyph from "../../assets/glyphs/captions.png";
import captionsFillGlyph from "../../assets/glyphs/captions-fill.png";
import fullscreenGlyph from "../../assets/glyphs/fullscreen.png";
import pauseFillGlyph from "../../assets/glyphs/pause-fill.png";
import chevronLeftGlyph from "../../assets/glyphs/chevron-left.png";
import chevronRightGlyph from "../../assets/glyphs/chevron-right.png";
import characterCircleGlyph from "../../assets/glyphs/character-circle.png";
import textPageGlyph from "../../assets/glyphs/text-page.png";

// SF Symbol glyphs (white-on-transparent PNGs) rendered as CSS masks so their
// color follows `currentColor`. This lets the same asset read white inside a
// dark chip and dark on a light surface without separate art per theme.
const GLYPHS = {
  bag: bagGlyph,
  popcorn: popcornGlyph,
  share: shareGlyph,
  captions: captionsGlyph,
  "captions-fill": captionsFillGlyph,
  fullscreen: fullscreenGlyph,
  pause: pauseFillGlyph,
  "chevron-left": chevronLeftGlyph,
  "chevron-right": chevronRightGlyph,
  "character-circle": characterCircleGlyph,
  "text-page": textPageGlyph,
};

export default function GlyphIcon({ name, className = "", title }) {
  const src = GLYPHS[name];
  if (!src) return null;
  return (
    <span
      className={`apple-glyph apple-glyph--${name}${className ? ` ${className}` : ""}`}
      role="img"
      aria-label={title || name}
      title={title}
      style={{
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
      }}
    />
  );
}
